/*
 * Purpose: App footer — Teknoled-G IP, version, support link
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { Link } from 'react-router-dom';
import { APP_ROUTES } from '@/lib/appRoutes';
import { VERSION_DISPLAY } from '@/lib/appVersion';
import { COMPANY_FOOTER_LINE, COPYRIGHT_NOTICE, COMPANY_INFO } from '@/lib/companyInfo';
import { AppVersionBadge } from '@/components/shell/AppVersionBadge';

export function AppFooter() {
  return (
    <footer className="shrink-0 border-t border-border/40 bg-muted/20 px-4 sm:px-6 py-4 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3 text-xs text-muted-foreground">
        <div className="min-w-0 space-y-1">
          <p className="font-medium text-foreground/90">
            <a
              href={COMPANY_INFO.officialUrl}
              className="hover:underline underline-offset-2"
              title="Autoblocks.run — official product app"
            >
              {COMPANY_INFO.productName}
            </a>
          </p>
          <p>{COPYRIGHT_NOTICE}</p>
          <p className="leading-relaxed">{COMPANY_FOOTER_LINE}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:ml-auto shrink-0">
          <AppVersionBadge />
          <span className="hidden sm:inline text-border">·</span>
          <Link to={APP_ROUTES.systemStatus} className="underline-offset-2 hover:underline" title="Live uptime and security status">
            System status
          </Link>
          <span className="text-border">·</span>
          <Link to={APP_ROUTES.pricing} className="underline-offset-2 hover:underline" title="Subscription plans">
            Pricing
          </Link>
          <span className="text-border">·</span>
          <a
            href={COMPANY_INFO.marketingUrl}
            className="underline-offset-2 hover:underline"
            title="Autoblocks marketing — overview"
            rel="noopener noreferrer"
          >
            autoblocks.pro
          </a>
          <span className="text-border">·</span>
          <Link to={APP_ROUTES.help} className="underline-offset-2 hover:underline" title="Help migrating from Zapier, Make, or n8n">
            Support
          </Link>
          <span className="text-border">·</span>
          <Link to={`${APP_ROUTES.help}?tab=about`} className="underline-offset-2 hover:underline">
            {VERSION_DISPLAY}
          </Link>
        </div>
      </div>
    </footer>
  );
}
